<template>
  <adminTable
    :hideSeachButton="false"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      
      <el-form-item label="用户名">
        <el-input v-model="searchForm.username" clearable />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="searchForm.phone" clearable />
      </el-form-item>
      <el-form-item label="账号类型">
        <el-select v-model="searchForm.is_test" placeholder="" clearable>
          <el-option v-for="item in accountTypeEnums" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-col :span="11">
          <el-date-picker
            v-model="searchForm.starttime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="开始时间"
            style="width: 100%"
          />
        </el-col>
        <el-col :span="2" class="text-center">
          <span class="text-gray-500">-</span>
        </el-col>
        <el-col :span="11">
          <el-date-picker
            v-model="searchForm.endtime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="结束时间"
            style="width: 100%"
          />
        </el-col>
      </el-form-item>
    </template>

    <template v-slot:query-button-right>
      <el-button
        type="primary"
        icon="CirclePlus"
        @click="editItem('add', {})"
        v-permission
      >添加</el-button>
    </template>

    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="phone" label="手机号" width="160">
        <template #default="scope">
          <span >{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" width="120">
        <template #default="scope">
          <span >{{ scope.row.uid }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户名" width="160">
        <template #default="scope">
          <span v-is-test="scope.row.is_test">{{ scope.row.username }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="is_test" label="账号类型" width="130">
        <template #default="scope">
          <span >{{ getLabelByVal(scope.row.is_test, accountTypeEnums) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="raffle_id" label="奖品ID" width="120" />
      <el-table-column prop="raffle.title" label="奖品标题" width="180" >
        <template #default="scope">
          <span >{{ scope.row.raffle.title }}</span>
          <span >({{ scope.row.raffle.words || scope.row.raffle.money }})</span>
        </template>
      </el-table-column>
      <el-table-column label="奖品类型" width="130">
        <template #default="scope">
          {{ getLabelByVal(scope.row.raffle.type, lottoryTypeBEnums) }}
        </template>
      </el-table-column>
      <el-table-column prop="raffle.money" label="奖品金额" width="120" />
      <el-table-column prop="raffle.words" label="集字" width="120" />
      <el-table-column label="状态" width="120">
        <template #default="scope">
          {{ getLabelByVal(scope.row.status, assignStatusEnums) }}
        </template>
      </el-table-column>
      <el-table-column prop="create_at" label="创建时间" width="180" />
      <el-table-column prop="update_at" label="更新时间" width="180" />
      <el-table-column label="操作" fixed="right" width="200" v-if="currentUser.role == 0">
        <template #default="scope">
          <el-button type="danger" icon="Delete" v-permission @click="deleteAction(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </template>

    <el-dialog v-model="dialogFlag" title="新增抽奖预设" width="700">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm">保存</el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import editPop from "./components/assignLists/editPop.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lottoryTypeBEnums, getLabelByVal, assignStatusEnums, accountTypeEnums } from "@/config/enums";

const dialogFlag = ref(false);
const editFormRef = ref(false);
const editRow = ref({});
const formType = ref("add");
const searchForm = ref({ starttime: "", endtime: "", username: "", phone: "", is_test: "" });

onMounted(() => {
  getList();
});

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);

const getList = async () => {
  tableLoading.value = true;
  const params = {
    page: page.value,
    limit: limit.value,
  };
  if (searchForm.value.starttime) params.starttime = searchForm.value.starttime;
  if (searchForm.value.endtime) params.endtime = searchForm.value.endtime;
  if (searchForm.value.username) params.username = searchForm.value.username;
  if (searchForm.value.phone) params.phone = searchForm.value.phone;
  if (searchForm.value.is_test !== "" && searchForm.value.is_test !== null && searchForm.value.is_test !== undefined) params.is_test = searchForm.value.is_test;
  const res = await proxy.$http({
    type: "get",
    url: "/Words/getAssignLists",
    params,
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};

const editItem = (type, row) => {
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const submitForm = async () => {
  const data = editFormRef.value.form;
  const res = await proxy.$http({
    method: "post",
    url: "Words/addAssign",
    data: {
      phone: data.phone,
      raffle_id: data.raffle_id,
      status: data.status ?? 0,
    },
  });

  if (res.code == 0) {
    dialogFlag.value = false;
    getList();
    ElMessage({ type: "success", message: res.msg });
  } else {
    dialogFlag.value = false;
    ElMessage({ type: "error", message: res.msg });
  }
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "Words/deleteAssign?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({ type: "success", message: res.msg });
    })
    .catch(() => {
      ElMessage({ type: "info", message: "取消删除" });
    });
};
</script>

<style lang="less" scoped></style>